import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import logoVSP from "../../assets/images/VUF-Logo-curve.svg";
const AccessDenied = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // optional cleanup
    localStorage.removeItem("token");
    localStorage.removeItem("role");
  }, []);

  return (
    <div className="ad-wrapper">
      <div className="ad-card">
        {/* Logo */}
        <img src={logoVSP} alt="VUF Logo" className="ad-logo" />

        {/* Icon */}
        <div className="ad-icon">🚫</div>

        <h1>Access Denied</h1>
        <p>
          You do not have permission to access this page.
          <br />
          <strong>Admin access only.</strong>
        </p>

        <button onClick={() => navigate("/", { replace: true })}>
          Go to Login
        </button>
      </div>

      {/* Styles */}
      <style>{`
        .ad-wrapper {
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(135deg, #f4f6fb, #eef1f7);
        }

        .ad-card {
          background: #ffffff;
          padding: 48px 42px;
          border-radius: 18px;
          text-align: center;
          max-width: 420px;
          width: 90%;
          box-shadow: 0 20px 45px rgba(0,0,0,0.08);
          animation: slideUp 0.6s ease-out;
        }

        .ad-logo {
          height: 108px;
          margin-bottom: 18px;
        }

        .ad-icon {
          font-size: 64px;
          margin-bottom: 16px;
          animation: pulse 1.6s infinite;
        }

        h1 {
          margin: 0;
          font-size: 28px;
          color: #1f2937;
        }

        p {
          margin: 14px 0 28px;
          color: #6b7280;
          line-height: 1.6;
          font-size: 15px;
        }

        button {
          background: linear-gradient(135deg, #6c63ff, #5a52e8);
          color: #fff;
          border: none;
          padding: 14px 32px;
          font-size: 15px;
          font-weight: 600;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.25s ease;
        }

        button:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(108, 99, 255, 0.35);
        }

        button:active {
          transform: translateY(0);
          box-shadow: none;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.08); }
          100% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default AccessDenied;
